export default "__VITE_ASSET__81dda68a__"